module.exports = {"username":"Username","password":"Password","button":"Login","error.username":"Username is required","error.password":"Password is required"}